import { axiosInstance } from '../axios';

const API_URL = '/api/corporations';

class CorporationsService {

    async list(params) {

        let queryParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
            if (value === null || value === undefined){
                continue;
            }
            queryParams.append(key, value);

        }
        return axiosInstance.get(
            `${API_URL}/list`,
            {
                params: queryParams,
            },
        );
    }

    async get(corporationId) {
        return axiosInstance.get(
            `${API_URL}/get/${corporationId}`);
    }

    async save(corporation) {
        return axiosInstance.post(
            `${API_URL}/save`,
            corporation,
        );
    }

    async delete(corporationIds) {
        let data = new FormData();
        corporationIds.forEach(id => data.append('ids', id) );
        return axiosInstance.delete(
            `${API_URL}/delete`,
            { data:data },
        );
    }

    async undelete(corporationIds) {
        let queryParams = new URLSearchParams();
        corporationIds.forEach(id => queryParams.append('ids', id) );
        return axiosInstance.post(
            `${API_URL}/undelete`,
            { },
            {
                params: queryParams,
            },
        );
    }
}

export default new CorporationsService();
